module.exports = __webpack_public_path__ + "img/milva-logo-white.9971db36.svg";